import { PromptDisplayModal } from "./PromptDisplayModal";

interface PlanWithAgentModalProps {
  open: boolean;
  onClose: () => void;
  agentId: string;
  agentName: string;
}

/**
 * "Plan with this agent" (Sprint 8) — now a thin wrapper over the generalised
 * {@link PromptDisplayModal} (Sprint 3 S3.24). Composes the `plan-with-agent`
 * prompt (persona + ranked tasks + in-progress tasks + recent activity)
 * and surfaces it for copy / hand-off to Claude or Cursor. The host does the
 * planning — no in-Kuvio chat by design.
 *
 * Backward-compatible: Sprint 8 callers pass the same props unchanged.
 */
export function PlanWithAgentModal({ open, onClose, agentId, agentName }: PlanWithAgentModalProps) {
  return (
    <PromptDisplayModal
      open={open}
      onClose={onClose}
      title={`Plan with ${agentName}`}
      subtitle="Persona + tasks + activity, ready to paste into Claude or Cursor"
      icon="wand"
      promptName="plan-with-agent"
      args={{ agent_id: agentId }}
    />
  );
}
